import type {Dispatch} from 'react'
import {
  Button,
  Dialog,
  DialogTrigger,
  Group,
  Input,
  Label,
  NumberField,
  Popover,
} from 'react-aria-components'

import ChevronDownSvg from '@/assets/icons/chevron-down.svg?react'

import style from './FilterBags.module.scss'

interface Props {
  carryOnBags: number
  onCarryOnBagsChange: Dispatch<number>
  errorMessage?: string
}

export default memo<Props>(function FilterBags(props) {
  return (
    <DialogTrigger>
      <Button className={style.Button}>
        <div className={style.Value}>
          <span>
            {props.carryOnBags} carry-on bag{props.carryOnBags > 1 ? 's' : ''}
          </span>
        </div>
        <span aria-hidden className={style.Chevron}>
          <ChevronDownSvg
            className={style.ChevronIcon}
            width={12}
            height={16}
            viewBox='0 0 24 24'
            aria-hidden
          />
        </span>
      </Button>
      <Popover className={style.Popover}>
        <Dialog className={style.Dialog}>
          <ul>
            <li>
              <NumberField
                className={style.NumberField}
                value={props.carryOnBags}
                onChange={props.onCarryOnBagsChange}
                minValue={0}
                maxValue={2}
              >
                <Label>Carry-on bag</Label>
                <Group className={style.Group}>
                  <Button slot='decrement'>-</Button>
                  <Input />
                  <Button slot='increment'>+</Button>
                </Group>
              </NumberField>
            </li>
          </ul>
          <div
            role='alert'
            className={clsx(style.ErrorMessage, !props.errorMessage && style.NoError)}
          >
            {props.errorMessage}
          </div>
        </Dialog>
      </Popover>
    </DialogTrigger>
  )
})
